import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/tutorials_2.svg'
import _imports_1 from '@/assets/images/tutorials_3.svg'
import _imports_2 from '@/assets/images/tutorials_4.svg'
import _imports_3 from '@/assets/images/tutorials_5.svg'
import _imports_4 from '@/assets/images/tutorials_6.svg'
import _imports_5 from '@/assets/images/tutorials_7.svg'


const _withScopeId = n => (_pushScopeId("data-v-3afea258"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"overflow":"hidden"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "p-mt-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"340px"} }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "i-frame",
    src: "https://www.youtube.com/embed/S6v1QZ675AI",
    title: "YouTube video player",
    allow: "accelerometer; autoplay; clipboard-write;\n                   encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "tut-1-text p-mt-2" }, "Check this example G.IO Creator Campaign Process ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex wiz-pos" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dash" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "margin-text p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title p-mt-4" }, "Upload Content"),
  /*#__PURE__*/_createElementVNode("div", { class: "guidance p-mt-4" }, "You can browse & drop content from your computer and directly place it on the platform.")
], -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "p-ml-6"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex wiz-pos-tutorials" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "margin-text p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title p-mt-4" }, "Upload Content"),
  /*#__PURE__*/_createElementVNode("div", { class: "guidance p-mt-4" }, "You can browse & drop content from your computer and directly place it on the platform.")
], -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "p-ml-6"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex wiz-pos-tutorials" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "margin-text p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title p-mt-4" }, "Content details"),
  /*#__PURE__*/_createElementVNode("div", { class: "guidance p-mt-4" }, "You can browse & drop content from your computer and directly place it on the platform.")
], -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "p-ml-6"
  })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex wiz-pos-tutorials" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "margin-text p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title p-mt-4" }, "PAID PARTNERSHIP"),
  /*#__PURE__*/_createElementVNode("div", { class: "guidance p-mt-4" }, "You can browse & drop content from your computer and directly place it on the platform.")
], -1))
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "p-ml-6"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex wiz-pos-tutorials" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "margin-text p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title p-mt-4" }, "CONTENT PREVIEW"),
  /*#__PURE__*/_createElementVNode("div", { class: "guidance p-mt-4" }, "You can browse & drop content from your computer and directly place it on the platform.")
], -1))
const _hoisted_27 = {
  class: "p-flex-column p-mt-6 p-jc-center",
  style: {"margin-left":"222px"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "p-ml-6"
  })
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex wiz-pos-tutorials" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dash" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "margin-text p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title p-mt-4" }, "PASTE YOUR INFLUENCER LINK"),
  /*#__PURE__*/_createElementVNode("div", { class: "guidance p-mt-4" }, "Paste this link to your content in your channels to have access to insights and track progress.")
], -1))
const _hoisted_32 = {
  class: "p-d-flex p-justify-center p-mt-6",
  style: {"margin-right":"235px","gap":"20px","padding-bottom":"37px"}
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    style: {"margin-left":"35px"}
  })
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex wiz-pos-tutorials" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "margin-text p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-title p-mt-4" }, "PASTE YOUR INFLUENCER LINK"),
  /*#__PURE__*/_createElementVNode("div", { class: "guidance p-mt-4" }, "Paste this link to your content in your channels to have access to insights and track progress.")
], -1))
const _hoisted_37 = { class: "p-d-flex p-justify-center p-mt-6 next-tut-button" }
const _hoisted_38 = {
  key: 0,
  class: "p-d-flex p-justify-center p-mt-6 next-tut-buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      modal: true,
      visible: _ctx.show,
      class: "p-col-12 p-md-6 p-xl-4",
      dismissableMask: true,
      closable: true,
      style: {"width":"772px","height":"807px"},
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:show', false)))
    }, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_Transition, { key: "1" }, {
          default: _withCtx(() => [
            (_ctx.wizzardOverlaySteps === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.wizzardOverlaySteps === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.wizzardOverlaySteps === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_17))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.wizzardOverlaySteps === 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_22))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.wizzardOverlaySteps === 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_Button, {
                        label: "OK, Got it",
                        class: "button",
                        style: {"width":"184px"}
                      }),
                      _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showNextTutorials && _ctx.showNextTutorials(...args))),
                        class: "watch-link p-mt-3"
                      }, "watch link tutorial")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.nextTutorials === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                      class: "button button-skip",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:show', false)))
                    }, "SKIP"),
                    _createVNode(_component_Button, {
                      label: "Continue",
                      class: "button",
                      style: {"width":"184px"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextTutorials++))
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.nextTutorials === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35,
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("button", {
                      class: "button button-skip",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:show', false)))
                    }, "SKIP")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.wizzardOverlaySteps<=4 && !_ctx.nextTutorials)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("button", {
                class: "button button-skip",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:show', false)))
              }, "SKIP"),
              _createVNode(_component_Button, {
                label: "OK, Got it",
                class: "button",
                style: {"width":"184px"},
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:show', false)))
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}